// SECTION - AUTH
export const LOGOUT = 'LOGOUT'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
// SECTION - APP
export const FETCH_USER = 'FETCH_USER'
// SECTION - SETTING
export const CHANGE_THEME = 'CHANGE_THEME'
// SECTION - ELECTRON
